const CYRILLIC_TO_LATIN: Record<string, string> = {
	а: 'a',
	ә: 'a',
	б: 'b',
	в: 'v',
	г: 'g',
	ғ: 'g',
	д: 'd',
	е: 'e',
	ё: 'e',
	ж: 'zh',
	з: 'z',
	и: 'i',
	й: 'i',
	і: 'i',
	к: 'k',
	қ: 'q',
	л: 'l',
	м: 'm',
	н: 'n',
	ң: 'n',
	о: 'o',
	ө: 'o',
	п: 'p',
	р: 'r',
	с: 's',
	т: 't',
	у: 'u',
	ұ: 'u',
	ү: 'u',
	ф: 'f',
	х: 'h',
	һ: 'h',
	ц: 'ts',
	ч: 'ch',
	ш: 'sh',
	щ: 'sch',
	ъ: '',
	ы: 'y',
	ь: '',
	э: 'e',
	ю: 'yu',
	я: 'ya'
};

/**
 * Транслитерирует кириллицу в латиницу.
 * Apple Pay не принимает мерчанта с названием на кириллице,
 * поэтому имя мерчанта нужно приводить к латинице.
 */
const transliterate = (value: string): string => {
	if (!value) {
		return value;
	}

	return value.replace(/[а-яёәіғқңөұүһ]/gi, char => {
		const lower = char.toLowerCase();
		const latin = CYRILLIC_TO_LATIN[lower] ?? char;

		return char === lower
			? latin
			: latin.charAt(0).toUpperCase() + latin.slice(1);
	});
};

export default transliterate;
